import { render } from "./JuntaVirtualPage.vue?vue&type=template&id=1750b8c2&scoped=true"
import script from "./JuntaVirtualPage.vue?vue&type=script&lang=js"
export * from "./JuntaVirtualPage.vue?vue&type=script&lang=js"

import "./JuntaVirtualPage.vue?vue&type=style&index=0&id=1750b8c2&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1750b8c2"]])

export default __exports__